import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyGinBulkeditRoute: InvariantJiraRoute = {
	name: 'legacy-gin-bulkedit',
	path: '/(secure/views|issue)/bulkedit/Bulk(\\w+)([!%]?[\\w]*).jspa',
};
